import { atom } from 'jotai';

export const theme = atom({ primaryColor: '#622567', isDarktheme: false });
